import server from "./server";

export const getBlogCategoriesApi = async () => {
  const response = await server().get("/categories");
  return response.data;
};

export const getSingleBlogCategoryApi = async (id) => {
  const response = await server().get(`/categories/${id}`);
  return response.data;
};

export const addBlogCategoryApi = async (payload) => {
  const response = await server().post("/categories", payload);
  return response.data;
};

export const editBlogCategoryApi = async ({ id, data }) => {
  const response = await server().put(`/categories/${id}`, data);
  return response.data;
};

export const deleteBlogCategoryApi = async (id) => {
  const response = await server().delete(`/categories/${id}`);
  return response.data;
};
